import React from 'react';
import cx from 'classnames';

import styles from './PopoverHeader.module.scss';

export interface PopoverHeaderProps {
  /** Children of `Popover.Header`. */
  children?: React.ReactNode;
  /** CSS className for `Popover.Header` container. */
  className?: Parameters<typeof cx>[0];
}

export const PopoverHeader: React.FC<PopoverHeaderProps> = ({
  children,
  className,
}) => {
  return (
    <header className={cx(styles.popoverHeader, className)}>{children}</header>
  );
};

export default PopoverHeader;
export { styles };
